import styled from 'styled-components';

export const SelectDaysContainer = styled.div`
  display: flex;
  align-content: center;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 4px;
  }
`;
